import { createFileRoute, redirect } from "@tanstack/react-router";

import { trpc } from "~/libs/trpc.lib";
import { InvitationsStep } from "~/pages/onboard/steps/invitations-step";
import { hasPendingInviteStash } from "~/stores/onboarding";
import { organizationInvitations$ } from "~/stores/organization-invitations";

/**
 * Personal onboarding step #2 (optional): invitation chooser for pending
 * workspace and board invitations. If there are none, jump to workspace.
 */
export const Route = createFileRoute("/onboard/invitations")({
  beforeLoad: async ({ context }) => {
    if (context.user?.onboarding !== "invitations") {
      throw redirect({ to: "/onboard", replace: true });
    }
    const orgInviteCount = Object.keys(
      organizationInvitations$.get() ?? {},
    ).length;
    if (orgInviteCount > 0 || hasPendingInviteStash()) {
      return;
    }

    const boardInviteCount =
      (await trpc.boardInvitations.listPendingForUser.query()).length ?? 0;
    if (boardInviteCount === 0) {
      throw redirect({ to: "/onboard/workspace", replace: true });
    }
  },
  component: InvitationsStep,
});
